<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266"
        >Bill No：{{ formData.stockInNo }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.billStatusName }}</span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName }} at
        {{ formData.createDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyDate }}
      </span>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.Warehousing date') || '入库日期'"
            prop="inDate"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.inDate"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="
                $l('form_label_please_select_the_stockIn_date') ||
                  '请选择入库日期'
              "
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    formData: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      backDialogVisible: false,
      rules: {
        inDate: [
          {
            required: true,
            message:
              this.$l('form_label_please_select_the_stockIn_date') ||
              '请选择入库日期',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    async getFormData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )
        return
      }
      return this.formData
    }
  }
}
</script>
